import {
  Autocomplete,Box,Button,CircularProgress,Dialog,DialogActions,DialogContent,DialogTitle,FormControl,FormControlLabel,InputLabel,MenuItem,Radio,RadioGroup,Select,Stack,Switch,TextField,Typography,
} from "@mui/material";

export default function ModalGroupPermissions({
  open,
  form,
  setForm,
  groups,
  accessPoints,
  schedules,
  members,
  selectedExcludedMembers,
  membersLoading,
  saving,
  onClose,
  onSave,
  onGroupChange,
}){
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {form.id?"Editar permiso por rol":"Nuevo permiso por rol"}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2.5} sx={{paddingTop:1}}>
          <FormControl fullWidth>
            <InputLabel>Rol</InputLabel>

            <Select value={form.group} label="Rol" onChange={onGroupChange}>
              {groups
                .filter(group=>group.is_active||group.id===Number(form.group))
                .map(group=>(
                  <MenuItem key={group.id} value={group.id}>
                    {group.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Acceso</InputLabel>

            <Select
              value={form.access_point}
              label="Acceso"
              onChange={event=>setForm(previous=>({...previous,access_point:event.target.value}))}
            >
              {accessPoints
                .filter(accessPoint=>accessPoint.is_active||accessPoint.id===Number(form.access_point))
                .map(accessPoint=>(
                  <MenuItem key={accessPoint.id} value={accessPoint.id}>
                    {accessPoint.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Horario</InputLabel>

            <Select
              value={form.schedule}
              label="Horario"
              onChange={event=>setForm(previous=>({...previous,schedule:event.target.value}))}
            >
              <MenuItem value="">Sin horario</MenuItem>

              {schedules
                .filter(schedule=>schedule.is_active||schedule.id===Number(form.schedule))
                .map(schedule=>(
                  <MenuItem key={schedule.id} value={schedule.id}>
                    {schedule.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <Box sx={{border:"1px solid #e5e7eb",borderRadius:2,paddingX:2,paddingY:1}}>
            <Typography sx={{fontSize:13,fontWeight:800,marginBottom:0.5}}>
              Tipo de regla
            </Typography>

            <RadioGroup
              row
              value={form.is_allowed?"allow":"deny"}
              onChange={event=>setForm(previous=>({...previous,is_allowed:event.target.value==="allow"}))}
            >
              <FormControlLabel value="allow" control={<Radio/>} label="Permitir acceso"/>
              <FormControlLabel value="deny" control={<Radio/>} label="Denegar acceso"/>
            </RadioGroup>
          </Box>

          <Box sx={{border:"1px solid #e5e7eb",borderRadius:2,padding:2}}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.limit_dates===true}
                  onChange={event=>{
                    const checked=event.target.checked;

                    setForm(previous=>({
                      ...previous,
                      limit_dates:checked,
                      valid_from:checked?previous.valid_from:"",
                      valid_until:checked?previous.valid_until:"",
                    }));
                  }}
                />
              }
              label="Limitar por fechas"
            />

            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
              Si está desactivado, el permiso no tendrá límite de fechas y seguirá respetando el horario semanal configurado.
            </Typography>

            {form.limit_dates&&(
              <Box
                sx={{
                  display:"grid",
                  gridTemplateColumns:{xs:"1fr",sm:"1fr 1fr"},
                  gap:2,
                  marginTop:2,
                }}
              >
                <TextField
                  fullWidth
                  required
                  type="date"
                  label="Válido desde"
                  value={form.valid_from}
                  onChange={event=>setForm(previous=>({...previous,valid_from:event.target.value}))}
                  InputLabelProps={{shrink:true}}
                />

                <TextField
                  fullWidth
                  required
                  type="date"
                  label="Válido hasta"
                  value={form.valid_until}
                  onChange={event=>setForm(previous=>({...previous,valid_until:event.target.value}))}
                  InputLabelProps={{shrink:true}}
                />
              </Box>
            )}
          </Box>

          <Box>
            <Typography sx={{fontSize:14,fontWeight:800,marginBottom:1}}>
              Usuarios excluidos de esta regla
            </Typography>

            {membersLoading?(
              <Box sx={{minHeight:90,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <CircularProgress size={24}/>
              </Box>
            ):(
              <Autocomplete
                multiple
                options={members}
                value={selectedExcludedMembers}
                getOptionLabel={option=>`${option.name} - ${option.identification}`}
                isOptionEqualToValue={(option,value)=>option.id===value.id}
                disabled={!form.group}
                onChange={(_,selectedMembers)=>{
                  setForm(previous=>({
                    ...previous,
                    excluded_person_ids:selectedMembers.map(member=>member.id),
                  }));
                }}
                renderInput={params=>(
                  <TextField
                    {...params}
                    label="Excluir usuarios"
                    placeholder={form.group?"Seleccionar usuarios":"Primero selecciona un rol"}
                  />
                )}
              />
            )}

            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.8}}>
              Los usuarios seleccionados no heredarán esta regla del rol.
            </Typography>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancelar
        </Button>

        <Button variant="contained" onClick={onSave} disabled={saving}>
          {saving?(
            <CircularProgress size={20} sx={{color:"#ffffff"}}/>
          ):form.id?(
            "Guardar cambios"
          ):(
            "Crear permiso"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}